import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // Onboarding steps data actions
  loadOnboardingStepsRequest: [],
  loadOnboardingStepsSuccess: ['stepsData'],
  loadOnboardingStepsFailure: ['error'],

  // Onboarding response submission actions
  submitOnboardingResponseRequest: ['responseData'],
  submitOnboardingResponseSuccess: ['responseData'],
  submitOnboardingResponseFailure: ['error'],
});

const onboardingActions = {
  Types,
  Creators,
};

export default onboardingActions;
